import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { OpenDeliverySimuladorForm } from "./components/OpenDeliverySimuladorForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Testar Open Delivery" />
            <Loading />
            <OpenDeliverySimuladorForm />
        </>
    )
}
